import isBase64 from './isBase64.js';

export const detectFileType = (value) => {
  if (typeof value !== 'string') {
    return '';
  }

  if (value.startsWith('http:') || value.startsWith('https:')) {
    return 'url';
  }

  if (isBase64(value)) {
    return 'base64';
  }

  const nonPrintableCount = (value.match(/[\x00-\x08\x0B-\x0C\x0E-\x1F]/g) || []).length; // eslint-disable-line
  if (value.includes('\x00') || nonPrintableCount / value.length > 0.1) {
    return 'binary';
  }

  return '';
};
